import { APP_STORE_URL } from "@/app/lib/constants";

const APPLE_PATH =
  "M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 790.7 0 663 0 541.8c0-207.5 135.4-317.3 269-317.3 70.2 0 128.7 46.3 172.6 46.3 42.4 0 109.1-49 188.1-49 30.4 0 110.4 2.6 168.1 80.5zm-221.9-145.9c31.1-37.5 53.7-89.5 53.7-141.5 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 84.4-55.1 139.2 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135-72.8z";

const variants = {
  small: {
    wrap: "gap-2.5 px-4 py-2.5",
    svgW: 14,
    svgH: 17,
    labelPx: "9px",
    titlePx: "14px",
  },
  medium: {
    wrap: "gap-3 px-6 py-3.5",
    svgW: 18,
    svgH: 22,
    labelPx: "10px",
    titlePx: "17px",
  },
  large: {
    wrap: "gap-3 px-8 py-4",
    svgW: 24,
    svgH: 28,
    labelPx: "12px",
    titlePx: "22px",
  },
};

export function AppStoreCTA({
  size = "large",
}: {
  size?: "small" | "medium" | "large";
}) {
  const v = variants[size];
  return (
    <a
      href={APP_STORE_URL}
      className={`inline-flex items-center rounded-full transition-opacity hover:opacity-80 ${v.wrap}`}
      style={{ backgroundColor: "#000" }}
    >
      <svg width={v.svgW} height={v.svgH} viewBox="0 0 814 1000" fill="white">
        <path d={APPLE_PATH} />
      </svg>
      <div className="flex flex-col">
        <span
          className="font-nunito leading-none mb-0.5"
          style={{ fontSize: v.labelPx, color: "rgba(255,255,255,0.65)" }}
        >
          Download on the
        </span>
        <span
          className="font-nunito font-bold leading-none"
          style={{ fontSize: v.titlePx, color: "#fff" }}
        >
          App Store
        </span>
      </div>
    </a>
  );
}
